import { translate } from '@lucidlink/uicore';
// Duplicate of services/validation/filespace-validation-checklists' rule with different wording; which one to keep needs a product decision.
export function filespaceNameValidationRules() {
    return [
        {
            errorCodes: ['filespace.name.invalidChar'],
            label: translate('Must contain only lowercase letters, numbers or hyphens'),
        },
        {
            errorCodes: ['filespace.name.startChar', 'filespace.name.endChar'],
            label: translate('Must start and end with a lowercase letter or number'),
        },
        {
            errorCodes: [
                'filespace.name.minLength',
                'filespace.name.maxLength',
            ],
            label: translate('Must be at least 2 and no more than 30 characters long'),
        },
    ];
}
